<template>
    <Modal :title="$t('operation_log.operationLog')" v-model="dialogVisible" width="55%" footer-hide>
        <Table :no-data-text="$t('common.noData')" :columns="columns" :data="alertRuleOperationLogDate" style="width: 100.1%;" class="table-css" height="500"></Table>
    </Modal>
</template>
<script>
    export default {
        name: 'AlertRuleOperationLog',
        data () {
            return {
                dialogVisible: false,
                columns: [
                {
                    title: this.$t('operation_log.operationMonitorModuleName'),
                    key: 'operationMonitorModuleName'
                },
                {
                    title: this.$t('operation_log.operationFieldName'),
                    key: 'operationFieldName'
                },
                {
                    title: this.$t('operation_log.operationOriginValue'),
                    key: 'operationOriginValue'
                },
                {
                    title: this.$t('operation_log.operationNewValue'),
                    key: 'operationNewValue'
                },
                {
                    title: this.$t('operation_log.createdBy'),
                    key: 'createdBy'
                },
                {
                    title: this.$t('operation_log.createdTime'),
                    key: 'createdTime'
                }],
                alertRuleOperationLogDate:[]
            }
        },
        methods: {
            getAlertRuleOperationLogData:function(row) {
                this.dialogVisible = true;
                this.$api.alertRuleOperationLog.listOperationLogByAlertRuleId("alertRuleId",row.id)
                .then(res => {
                    this.alertRuleOperationLogDate = res.data;
                });
            },
            getContactOperationLogData:function(row) {
                this.dialogVisible = true;
                this.$api.contact.listContactOperationLogByContactGroupId("contactId",row.id)
                .then(res => {
                    this.alertRuleOperationLogDate = res.data;
                });
            },
            getContactGroupOperationLogData:function(row) {
                this.dialogVisible = true;
                this.$api.contactGroup.listContactGroupOperationLogByContactGroupId("contactGroupId",row.id)
                .then(res => {
                    this.alertRuleOperationLogDate = res.data;
                });
            }
        }
    }
</script>
<style scoped>
    /* 滚动条 */
    .table-css >>> .ivu-table-overflowY::-webkit-scrollbar {
        width: 10px;
        height: 10px;
    }
    .table-css >>> .ivu-table-overflowY::-webkit-scrollbar-thumb {
        border-radius: 5px;
        background: #ccc;
    }
    .table-css >>> .ivu-table-overflowY::-webkit-scrollbar-track {
        background: #eeeeef;
    }
    .table-css >>> .ivu-table-overflowY::-webkit-scrollbar-corner {
        background-color: #eeeeef;
    }
    .table-css >>> .ivu-table-overflowX{
        overflow-x: hidden !important;
    }
</style>



// WEBPACK FOOTER //
// src/components/monitor/common/AlertRuleOperationLog.vue